<template>
  <main>
    <div class="block">
      <div class="page-title">
        <h2>
          <a href="#" title="中央內容導盲磚" accesskey="C">:::</a>水庫水情
        </h2>
        <div class="bread">
          <router-link to="/">首頁</router-link><span>/</span
          ><router-link to="/monitor/reservoir">監控資訊</router-link
          ><span>/</span
          ><router-link to="/monitor/reservoir">水庫水情</router-link>
        </div>
      </div>
    </div>
    <div class="block bg-gradual">
      <div class="inner container">
        <div class="page-tab-group">
          <div
            title="水庫蓄水視覺化展示"
            :class="'page-tab' + (selectedTab == 'a' ? ' current' : '')"
            @click="selectedTab = 'a'"
            @keyup.enter="selectedTab = 'a'"
            tabindex="0"
          >
            <h3>水庫蓄水視覺化展示</h3>
          </div>
          <div
            title="水庫即時資訊"
            :class="'page-tab' + (selectedTab == 'b' ? ' current' : '')"
            @click="selectedTab = 'b'"
            @keyup.enter="selectedTab = 'b'"
            tabindex="0"
          >
            <h3>水庫即時資訊</h3>
          </div>
          <div
            title="水庫蓄水統計表"
            :class="'page-tab' + (selectedTab == 'c' ? ' current' : '')"
            @click="selectedTab = 'c'"
            @keyup.enter="selectedTab = 'c'"
            tabindex="0"
          >
            <h3>水庫蓄水統計表</h3>
          </div>
          <div
            title="水庫水情比對分析"
            :class="'page-tab' + (selectedTab == 'd' ? ' current' : '')"
            @click="selectedTab = 'd'"
            @keyup.enter="selectedTab = 'd'"
            tabindex="0"
          >
            <h3>水庫水情比對分析</h3>
          </div>
        </div>
        <div class="living-view" v-show="selectedTab == 'a'">
          <ul class="small">
            <li class="text-dark">水庫資料更新機制為各水庫管理單位自行登打，因此各水庫更新時間不一致非資料錯誤。</li>
            <li class="text-dark">有效蓄水量係指水庫目前之蓄水量，非指水庫容量。</li>
            <li class="text-dark">本日累積雨量中「--」代表降雨量0毫米或無資料。</li>
          </ul>
          <br>
          <div v-for="item in reservoirAccumulatedRainfall" :key="item.AreaCode">
            <h4 class="sub-title">{{ item.AreaName }}</h4>
            <div class="wrapper">
              <div class="reservoir" v-for="i in item.ReservoirRealTimeInfos" :key="i.StationNo">
                <h2 tltle="石門水庫">{{ i.StationName.zh_TW }}</h2>
                <p class="text-dark">
                  本日累積降雨量： 
                  <b class="blue">{{ i.AccumulatedRainfall }}</b>
                  mm
                </p>
                <p class="text-dark">
                  昨日累積降雨量：
                  <b class="blue">{{ i.YesterdayAccumulatedRainfall }}</b>
                  mm
                </p>
                <p class="text-dark">
                  有效蓄水量：<b class="blue">{{ i.EffectiveStorage }}</b>
                  萬立方公尺
                </p>
                <p class="text-dark">
                  有效庫容量：<b class="blue">{{ i.EffectiveCapacity }}</b>
                  萬立方公尺
                </p>
                <div class="reservoir-section">
                  <div class="progress-bar">
                    <div class="trapezoidal"></div>
                    <div class="progress-bar__fill" :style="{ '--percent': `${ i.Percent }%` }"></div>
                    <div class="progress-bar__value">{{ i.Percent }}%</div>
                  </div>
                </div>
                <p class="text-center">
                  <small>Update： {{ i.Time }}</small>
                </p>
              </div>
            </div>
          </div>
          <div>
            <h4 class="sub-title">堰壩</h4>
            <div class="wrapper">
              <div class="reservoir" v-for="i in turbidity" :key="i.StationNo">
                <h2 title="石岡壩">{{ i.StationName }}</h2>
                <p class="text-dark">
                  進流量/濁度：
                  <b class="blue">{{ i.Runoff }} cms / {{ i.Turbidity }} NTU</b>
                </p>
                <p class="text-dark">
                  水情時間：
                  <b class="blue">{{ i.Time }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="news-list-table" v-show="selectedTab == 'b'">
          <iframe
            src="https://fhy.wra.gov.tw/ReservoirPage_2011/Statistics.aspx"
            scrolling="yes"
            frameborder="0"
            title="ReservoirPage_2011 Statistics"
          ></iframe>
        </div>
        <div class="news-list-table" v-show="selectedTab == 'c'">
          <iframe
            src="https://fhy.wra.gov.tw/ReservoirPage_2011/StorageCapacity.aspx"
            scrolling="yes"
            frameborder="0"
            title="ReservoirPage_2011 StorageCapacity"
          ></iframe>
        </div>
        <div class="news-list-table" v-show="selectedTab == 'd'">
          <iframe
            src="https://fhy.wra.gov.tw/disaster/Reservoir/Comparison"
            scrolling="yes"
            frameborder="0"
            title="Reservoir Comparison"
          ></iframe>
        </div>
      </div>
    </div>
    <loading :active.sync="isLoading"></loading>
    <commonfunctions></commonfunctions>
  </main>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import commonfunctions from "../shared/commonfunctions";

export default {
  metaInfo: {
    title: "經濟部水利署防災資訊網-監控資訊-水庫水情",
  },
  components: {
    Loading,
    commonfunctions,
  },
  data() {
    return {
      isLoading: false,
      selectedTab: "a",
      reservoirAccumulatedRainfall: [],
      turbidity: [],
    };
  },
  async mounted() {
    //水庫蓄水視覺化展示
    try {
      this.isLoading = true;

      let visualData = (await this.$http.get("https://fhyv.wra.gov.tw/FhyWeb/v1/Api/Reservoir/Visual?$format=JSON")).data;
      await this.transformVisual(visualData);
      this.reservoirAccumulatedRainfall = visualData;

      //排除白河水庫
      let south = this.reservoirAccumulatedRainfall.find(item => item.AreaName == "南區");
      south.ReservoirRealTimeInfos = south.ReservoirRealTimeInfos.filter(item => item.StationName.zh_TW !="白河水庫")

      let turbidityData = (await this.$http.get("https://fhyv.wra.gov.tw/FhyWeb/v1/Api/Reservoir/Turbidity/RealTimeInfo?$format=JSON")).data;
      await this.transformTurbidity(turbidityData);
      this.turbidity = turbidityData;
    } catch (error) {
      console.log(error)
      this.reservoirAccumulatedRainfall = [];
      this.turbidity = [];
    } finally {
      this.isLoading = false;
    }

  },
  methods: {
    transformVisual(val){
      val.forEach(element => {
        element.ReservoirRealTimeInfos.forEach(info => {
          let percent = Math.round(info.PercentageOfStorage * 100) / 100;
          info.Time = info.Time ? info.Time.substring(5, 16).replace("T", " ") : "--";
          info.AccumulatedRainfall = info.AccumulatedRainfall ? parseFloat(info.AccumulatedRainfall).toFixed(1) : "--";
          info.YesterdayAccumulatedRainfall = info.YesterdayAccumulatedRainfall || info.YesterdayAccumulatedRainfall == "0.0" ? 
                                                  (info.YesterdayAccumulatedRainfall == "0.0" ? info.YesterdayAccumulatedRainfall : parseFloat(info.YesterdayAccumulatedRainfall).toFixed(1)) : 
                                                  "--";
          info.Percent = percent != 100 ? parseFloat(percent).toFixed(1) : percent;
          info.EffectiveStorage = this.formatNumber(parseFloat(info.EffectiveStorage).toFixed(1));
          info.EffectiveCapacity = this.formatNumber(parseFloat(info.EffectiveCapacity).toFixed(1));
        })
      });
    },
    transformTurbidity(val){
      val.forEach(element => {
        element.Time = element.Time.substring(0, 16).replace("T", " ");
      })
    },
    formatNumber(val){
      val += "";
      let arr = val.split(".");
      let re = /(\d{1,3})(?=(\d{3})+$)/g;
      return arr[0].replace(re, "$1,") + (arr.length == 2 ? "." + arr[1] : "");
    }
  },
};
</script>

<style>
iframe {
  width: 100%;
  height: 720px;
}
ul{
  margin-left: 20px;
}
li{
  list-style-type: disc;
  margin-bottom: 5px;
}
.wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
@media only screen and (max-width: 800px) {
  .wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
.wrapper .reservoir {
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#feffff+0,e8f6ff+100 */
  background: #fff; /* Old browsers */
  overflow-x: hidden;
  margin: 10px;
  border-radius: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
}
.wrapper .reservoir h2 {
  background-color: #008788;
  padding: 10px 8px;
  color: #fff;
  margin: 0px;
  font-size: 18px;
  text-align: center;
}
.wrapper .reservoir p {
  font-size: 0.9rem;
  margin: 5px 8px;
}
.wrapper .reservoir small {
  font-size: 0.85rem;
  color: #888;
}
.wrapper .reservoir .text-center {
  text-align: center;
}
.wrapper .reservoir .blue {
  color: blue !important;
  font-size: 1rem;
}
.wrapper .reservoir .red {
  color: red !important;
  font-size: 1rem;
}
.wrapper .reservoir-section {
  margin: 10px auto;
  text-align: center;
  position: relative;
  padding: 5px;
  width: 180px;
  height: 120px;
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#feffff+0,d0e5ed+100 */
}
/* ========================
Components
======================== */
.progress-bar {
  border-bottom: 5px solid #c7c7c7;
  border-radius: 5px;
  height: 100px;
  position: absolute;
  width: 180px;
  bottom: 0px;
}
.progress-bar__fill {
  background-color: #c7e9ff;
  bottom: 0;
  box-sizing: border-box;
  -webkit-clip-path: polygon(
    4px -15px,
    calc(100% - 4px) -15px,
    calc(100% - 4px) calc(100% - 0px),
    0px calc(100% - 0px)
  );
  clip-path: polygon(
    4px -15px,
    calc(100% - 4px) -15px,
    calc(100% - 4px) calc(100% - 0px),
    0px calc(100% - 0px)
  );
  height: calc(var(--percent) - 8px);
  position: absolute;
  width: 100%;
}
.progress-bar__fill::before {
  -webkit-animation: undulate 52s linear infinite;
  animation: undulate 52s linear infinite;
  background-image: url("../../../public/images/wave.svg");
  bottom: 100%;
  content: "";
  height: 15px;
  left: 0px;
  position: absolute;
  width: calc(1200% - 0px);
}
.progress-bar__value {
  color: #09345c;
  font-size: 40px;
  font-weight: bold;
  position: absolute;
  text-align: center;
  bottom: 20px;
  left: 15px;
  width: 100%;
}
/* ========================
Keyframes
======================== */
/* can't used，it remove to public/css/style.css */
/* @-webkit-keyframes undulate {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-50% + 0px));
  }
} */

/* ========================
External
======================== */
.trapezoidal {
  position: absolute;
  left: 0px;
  bottom: 4px;
  z-index: 1;
  width: 30px;
  height: 120px;
  background: #c7c7c7 left top no-repeat;
  background-size: cover;
  transform: perspective(0.5em) rotateX(1deg);
  transform-origin: left;
}
.trapezoidal {
  -moz-transform: perspective(0.5em) rotateX(1deg);
  -o-transform: perspective(0.5em) rotateX(1deg);
  -ms-transform: perspective(0.5em) rotateX(1deg);
  -moz-transform-origin: left;
  -o-transform-origin: left;
  -ms-transform-origin: left;
  /*裝飾用 */
  /*  background-image: linear-gradient(hsla(199, 93%, 50%, 0.6), hsla(177, 100%, 91%, 0.8)); */
}
</style>